// src/components/agent/AgentCard.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import { ClockIcon } from '@heroicons/react/24/outline'; // Pastikan sudah install @heroicons/react

const AgentCard = ({ agent }) => {
  const agentTypeName = agent.agent_type_name || agent.configuration?.serviceType || 'Utility';
  const shortId = agent.agent_id ? `${agent.agent_id.substring(0, 4)}...${agent.agent_id.substring(agent.agent_id.length - 4)}` : 'N/A';

  return (
    <div className="bg-slate-800/40 backdrop-blur-xl border border-white/5 rounded-3xl p-6 hover:border-indigo-500/30 transition-all duration-300 group flex flex-col h-full">
        {/* Header: Avatar + Info */}
        <div className="flex items-start gap-4 mb-6">
            <div className="w-14 h-14 rounded-full bg-gradient-to-br from-indigo-500 via-purple-500 to-pink-500 p-[2px] shadow-lg shadow-indigo-500/20">
                <div className="w-full h-full rounded-full bg-slate-900 flex items-center justify-center overflow-hidden">
                    {/* Placeholder Avatar */}
                    <span className="text-xl font-bold text-white uppercase">{agent.name?.charAt(0) || 'A'}</span>
                </div>
            </div>
            
            <div className="flex-1 min-w-0">
                <h3 className="text-xl font-bold text-white leading-tight truncate" title={agent.name}>
                    {agent.name || "Untitled Agent"}
                </h3>
                <p className="text-sm font-medium text-slate-500 mt-1">
                    ID: {shortId}
                </p>
            </div>
        </div>

        {/* Metrics Grid (Dummy Data for Visual Match) */}
        <div className="grid grid-cols-3 gap-0 mb-6 divide-x divide-slate-700/50">
            <div className="px-2 first:pl-0">
                <p className="text-[10px] text-slate-500 uppercase tracking-wider mb-1">Status</p>
                <p className="text-sm font-bold text-white">Active</p>
            </div>
            <div className="px-2 text-center">
                 <p className="text-[10px] text-slate-500 uppercase tracking-wider mb-1">Vol 24h</p>
                 <p className="text-sm font-bold text-white">$ --</p>
            </div>
             <div className="px-2 text-right last:pr-0">
                 <p className="text-[10px] text-slate-500 uppercase tracking-wider mb-1">Type</p>
                 <p className="text-sm font-bold text-white truncate max-w-[80px] ml-auto" title={agentTypeName}>
                     {agentTypeName.split(' ')[0]}
                 </p>
            </div>
        </div>

        {/* Tags / Chips */}
        <div className="flex items-center gap-2 mb-6 flex-wrap">
            <span className="px-3 py-1 rounded-full bg-slate-700/50 border border-slate-600/30 text-xs font-medium text-slate-300">
                {agentTypeName}
            </span>
             <span className="px-3 py-1 rounded-full bg-slate-700/50 border border-slate-600/30 text-xs font-medium text-slate-300">
                v1.0
            </span>
        </div>

        {/* Footer info & Action */}
        <div className="mt-auto">
            <div className="flex items-center justify-between pt-4 border-t border-slate-700/50 mb-4">
                <div className="flex items-center gap-1.5 text-xs text-slate-400">
                    <ClockIcon className="w-3.5 h-3.5" />
                    <span>Created recently</span>
                </div>
                 <div className="flex items-center gap-2">
                     <span className="text-xs text-slate-500">by</span>
                    <span className="text-xs font-medium text-white bg-slate-700/80 px-2.5 py-0.5 rounded-full">
                        Me
                    </span>
                </div>
            </div>

            <Link to={`/agent/${agent.agent_id}/run`}>
                <button className="w-full py-3 rounded-xl bg-gradient-to-r from-blue-600/10 to-indigo-600/10 hover:from-blue-600 hover:to-indigo-600 text-blue-400 hover:text-white font-semibold transition-all border border-blue-500/20 hover:border-transparent">
                    Run Agent
                </button>
            </Link>
        </div>
    </div>
  );
};

export default AgentCard;